import React from "react";
import { ErrorMessage } from "formik";
import { FaInfoCircle, FaMoneyBillWave } from "react-icons/fa";
import InfoTooltip from "../components/InfoTooltip";
import RadioButton from "../components/RadioButton";

export const Step3 = () => (
  <div className="h-full flex flex-col gap-5 step-enter">

    <div>
      <h2 className="text-base font-bold text-foreground">Cotisation</h2>
      <p className="text-xs text-muted-foreground mt-0.5">
        Choisissez votre statut et votre mode de règlement.
      </p>
    </div>

    {/* Rappel montant */}
    <div className="flex items-center justify-between px-4 py-3.5 rounded-xl bg-primary/10 border border-primary/25">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
          <FaInfoCircle className="h-4 w-4 text-primary" />
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Cotisation annuelle</p>
          <p className="text-2xl font-bold text-primary">15 €</p>
        </div>
      </div>
      <InfoTooltip
        title="Information cotisation"
        text="La cotisation annuelle est fixée par le réglement intérieur de l'association. Elle doit être effectuée au plus tard 30 jours après l'Assemblée Générale ordinaire clôturant la saison passée."
      />
    </div>

    {/* Statut */}
    <div className="flex flex-col gap-2">
      <label className="flex items-center gap-1.5 text-xs font-semibold text-foreground/75 uppercase tracking-wide select-none">
        <FaInfoCircle className="h-3 w-3 text-primary" />
        Statut <span className="text-secondary font-bold">*</span>
      </label>
      <div className="flex gap-2 flex-wrap">
        {["Adhésion", "Réadhésion"].map((o) => (
          <RadioButton key={o} name="statut" value={o} label={o} />
        ))}
      </div>
      <ErrorMessage name="statut" component="p" className="text-[10px] text-destructive" />
    </div>

    {/* Mode de paiement */}
    <div className="flex flex-col gap-2">
      <label className="flex items-center gap-1.5 text-xs font-semibold text-foreground/75 uppercase tracking-wide select-none">
        <FaMoneyBillWave className="h-3 w-3 text-primary" />
        Mode de paiement <span className="text-secondary font-bold">*</span>
      </label>
      <div className="flex gap-2 flex-wrap">
        {["Virement bancaire", "PayPal", "Espèces"].map((o) => (
          <RadioButton key={o} name="modePaiement" value={o} label={o} />
        ))}
      </div>
      <ErrorMessage name="modePaiement" component="p" className="text-[10px] text-destructive" />
    </div>
  </div>
);
